// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Support both frontend (Vite) and backend (Node.js) environments
const SUPABASE_URL = typeof window !== 'undefined' 
  ? import.meta.env?.VITE_SUPABASE_URL 
  : process.env.VITE_SUPABASE_URL || process.env.SUPABASE_URL;
  
const SUPABASE_ANON_KEY = typeof window !== 'undefined' 
  ? import.meta.env?.VITE_SUPABASE_ANON_KEY 
  : process.env.VITE_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY;

// Ensure environment variables are available
if (!SUPABASE_URL) {
  throw new Error('VITE_SUPABASE_URL is not defined. Please check your environment variables.');
}

if (!SUPABASE_ANON_KEY) {
  throw new Error('VITE_SUPABASE_ANON_KEY is not defined. Please check your environment variables.');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'light-hunt-auth',
      // Enhanced cookie options for better cross-domain handling
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      flowType: 'pkce',
      // Ensure session is maintained during external redirects
      debug: false,
      // Additional options for better session persistence
      retryDelay: 1000,
      // Use both localStorage and sessionStorage for redundancy during external redirects
      additionalHeaders: typeof window !== 'undefined' ? {
        'X-Client-Info': 'light-hunt-web'
      } : {}
    },
    global: {
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
        // Note: Removed 'Content-Type' to allow proper file uploads
        // Storage operations need to set their own content type
      }
    },
    db: {
      schema: 'public'
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    }
  }
);